import { useMemo } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useChecklistContext } from "context/ChecklistContext";

const ChecklistNavigation = () => {
  const { checklist } = useChecklistContext();
  const totalNumberOfChecklists = checklist.allChecklists.length || 0;
  const ordernr = checklist.partOfOrder;

  const currentIndex = useMemo(
    () => checklist.allChecklists.findIndex((id) => id === checklist.id) || 0,
    [checklist]
  );

  const prevId = checklist.allChecklists[currentIndex - 1];
  const nextId = checklist.allChecklists[currentIndex + 1];

  return (
    <Box display="flex" alignItems="center">
      <Tooltip arrow title="Föregående checklista">
        <IconButton
          component={RouterLink}
          to={`/orders/view/${ordernr}/checklist/${prevId}`}
          color="primary"
          disabled={currentIndex === 0}
        >
          <ArrowBackIcon />
        </IconButton>
      </Tooltip>

      <Typography>
        {currentIndex + 1} / {totalNumberOfChecklists}
      </Typography>

      <Tooltip arrow title="Nästa checklista">
        <IconButton
          component={RouterLink}
          to={`/orders/view/${ordernr}/checklist/${nextId}`}
          color="primary"
          disabled={currentIndex >= totalNumberOfChecklists - 1}
        >
          <ArrowForwardIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ChecklistNavigation;
